// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7470c3fb","455":"9c1b3725","977":"7f776f54"}[chunkId] + ".chunk.js";
};